import * as xlsx from "xlsx";

export async function excelBlobToJson(objectURL) {

  const response = await fetch(objectURL);
  const blob = await response.blob();
  const arrayBuffer = await blob.arrayBuffer();

  const workbook = xlsx.read(arrayBuffer, { type: "array" });

  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];

  const json = xlsx.utils.sheet_to_json(worksheet, {
    defval: null,
    raw: false
  });

  return json;
}